import React, { Component } from 'react';
import "./Popup.scss"
import { isMobile, isIos } from '../../static/helper';
import { GA_Event } from '../Analytics/Analytics';

const FingerSvg = () => (
    <svg className="finger-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 324.83 449.42">
        <defs>
        </defs>
        <title>Asset 1</title>
        <g id="Layer_2" data-name="Layer 2">
            <g id="Ñëîé_1" data-name="Ñëîé 1">
                <path className="cls-1" d="M324.47,265.92v-.28c-.08-3-.16-6-.21-8.76V219.67A53,53,0,0,0,322.38,206a38.55,38.55,0,0,0-6.74-15.07,34.26,34.26,0,0,0-29-15.53h-.09c-.59,0-1.19-.07-1.79-.07a44.5,44.5,0,0,0-13.73,2.07,36,36,0,0,0-7.42-14.2,38.35,38.35,0,0,0-45.45-12.8,38.38,38.38,0,0,0-49.3-26.56c0-28.2-.23-62.85-.34-77.86,0-4.18,0-6.88,0-7.54a38.39,38.39,0,1,0-76.77,0c0,2.39.28,155.7.3,162.21,0,4.5-.07,8.5-.19,12-6.1-7.72-13.14-16.19-21.62-26s-19.38-14.7-32.64-14.7A37.57,37.57,0,0,0,9.72,184.28,29.28,29.28,0,0,0,4,191.58a34,34,0,0,0-4,17c0,.29,0,.57,0,.86a37.5,37.5,0,0,0,1.46,10.35c2.18,9.29,7.36,18.3,12.37,27,1.37,2.4,2.74,4.77,4,7.11l.75,1.39c31,57.3,56.16,95,84.12,125.9,2,2.39,5.36,12,6.07,49.86l.06,2.9c0,1.62.08,3.37.14,5.17a10.59,10.59,0,0,0,10.59,10.26H273.89A10.59,10.59,0,0,0,284.48,439l.63-52.65q2.25-2.18,7.21-6.38c5.35-4.53,10-8.45,13-13C326.32,335.9,325.33,298.72,324.47,265.92Zm-36.71,89.23c-1.4,2.08-5.34,5.42-9.16,8.66-7.33,6.21-11.4,10-13.3,13.41a10.56,10.56,0,0,0-1.34,5l-.55,46H129.93c-.66-29.92-3-51.75-11.48-61.17C91.68,337.4,67.39,301,37.23,245.23l-.76-1.4c-1.35-2.49-2.8-5-4.26-7.56-4.29-7.46-8.72-15.18-10.15-21.48,0-.22-.11-.45-.18-.67a16.49,16.49,0,0,1-.68-4.44l0-.66v-.43a13.2,13.2,0,0,1,1.36-6.78,8.4,8.4,0,0,1,1.75-2.18,9.86,9.86,0,0,0,.91-.92,16.4,16.4,0,0,1,12.32-5.62c7.2,0,12.15,2.19,16.57,7.33,16.32,19,27.09,32.55,36,45.48l.54.76a10.59,10.59,0,0,0,18.75-3.14c2.5-8.3,3.76-22.74,3.76-42.94,0-1.6-.3-159.82-.3-162.19a17.2,17.2,0,0,1,34.39,0c0,.67,0,3.42,0,7.69.13,19,.49,69.42.25,98.26V171.1a10.6,10.6,0,1,0,21.2,0V148.22A17.13,17.13,0,0,1,198,157c.06.32.13.64.22,1a24,24,0,0,1,1,6.66v5.63s0,0,0,.08v26.56a10.6,10.6,0,0,0,21.2,0V174a17.1,17.1,0,0,1,26.32,1.95c.2.28.42.55.64.81A15.21,15.21,0,0,1,251.11,187a10.34,10.34,0,0,0,.07,1.11,60.67,60.67,0,0,1,.06,8.2,1.93,1.93,0,0,0,0,.24s0,.08,0,.12v26.66a10.6,10.6,0,1,0,21.19,0V200.51c3.54-3.25,8.5-4,12.31-4l1,.07h.63a13.8,13.8,0,0,1,8.66,2.8,14.63,14.63,0,0,1,3.13,3.53l.35.49a16.86,16.86,0,0,1,3.14,7c.05.27.12.55.19.81a32.61,32.61,0,0,1,1.21,8.47v37.42c.06,3,.14,6,.22,9.11v.28C304.06,296.1,305,329.67,287.76,355.15Z" />
            </g>
        </g>
    </svg>
)


export default class Popup extends Component {
    constructor() {
        super();
        this.state = {

        }
    }

    shareOverrideOGMeta(overrideLink, overrideTitle, overrideDescription) {
        window.FB.ui({
            method: 'share_open_graph',
            action_type: 'og.likes',
            action_properties: JSON.stringify({
                object: {
                    'og:url': overrideLink,
                    'og:title': overrideTitle,
                    'og:description': overrideDescription,
                    'og:image': `https://z.ynet.co.il/mshort/content/eurovision2019/fb2.png`,
                }
            })
        },
            function (response) {
                // Action after response
            });
        GA_Event("share_after_vote", 'facebook');
    }
    shareWhatsapp = () => {
        let url = '';
        let description = `${this.props.pupupShare.desc} ${this.props.pupupShare.url.replace("=", "%3D")}`
        if (isMobile() || isIos()) {
            url = `whatsapp://send?text=${description}`;
            window.open(url, "_parent");
        } else {
            url = `https://api.whatsapp.com/send?text=${description}`
            window.open(url, "_blank");
        }
        // let url = `whatsapp://send?text=${this.state.shareUrl}`;
        window.open(url, '_blank', "width=500,height=300");
        // this.props.sendGA("Share_Whatsapp", url);
        GA_Event("share_after_vote", 'whatsapp');

    }

    render() {
        return (
            <div className="popup-container">
                <div className="popup-wrapper">
                    {this.props.title.indexOf("תודה") <= -1 ?
                        <FingerSvg />
                        : ""
                    }
                    <div onClick={this.props.closePopup} className="close"></div>
                    <h2>{this.props.title}</h2>
                    <div className="desc">{this.props.desc}</div>
                    {this.props.pupupShare ?
                        <div className="popup-share-container">
                            <div className="desc">בטוחים בבחירות שלכם? <br /> שתפו אותן</div>

                            <div className="popup-share">
                                <div className="facebook" onClick={() => this.shareOverrideOGMeta(this.props.pupupShare.url, this.props.pupupShare.title, this.props.pupupShare.desc)}></div>
                                <div className="line"></div>
                                <div className="whatsapp" onClick={this.shareWhatsapp}></div>
                            </div>
                        </div>
                        : ""
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/Popup/Popup.jsx